'use strict';

var constants = require('../constants');

function getDomain(config) {
    if (config.domain) {
        return config.domain;
    } else if (config.sandBox) {
        return constants.SANDBOX_URL_ROOT;
    } else {
        return constants.LIVE_URL_ROOT;
    }
}

module.exports = getDomain;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/domain.js
 ** module id = 18
 ** module chunks = 0
 **/